export default "__VITE_ASSET__BRqRy7UF__"